module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAMpJREFUWEdjZBikgHGQuoth1GGkxszQCDGzhFsfGBgY2Ej1HRXV/zq1QE0AZB5KiJkl3PzFwMDASkWLSDXq96kF6uCAGSIOi795c8BDbKG6OkaIGSbfk2f99YuJ1PCnlvrfbGz/zs9VeojhMGpZQA1zhkZxQQ2fUsuM0RAjNSRHQ4yiEBu05ZjZYC35Rytx3AkOR+tisEbloE38pGZpWqofLWBJDd3REBueITZoi4vRupLkKmnw9sQH6dgFqVmalupHC1hSQ3fQhhgAgCZcJ6wBSDUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_more.png
// module id = mYqV
// module chunks = 1